import styled from 'styled-components';

const StyledNavigationSidebarWrapper = styled.section `
  background-color: ${props => props.theme.colors.backgroundColor};
  margin: 0 auto;
  padding: 12px 0 0;
`;
const StyledContainer = styled.div `
  padding: 0 1rem 1px;
`;

export { StyledContainer, StyledNavigationSidebarWrapper };
//# sourceMappingURL=MobileNavigation.styles.mjs.map
